export default "__VITE_ASSET__CSdOkkr5__"